(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tend-hero-slider"] && !Shopify.designMode) return;
  try {
    
  const tendHeroSwiper = new Swiper(".tend_hero_slider", {
    loop: true,
    speed: 800,
    // autoplay: false,
    autoplay: {
     delay: 10000,
     disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: null,
      clickable: false,
    },
    on: {
      init(swiper) {
        updateControls(swiper);
      },
      slideChange(swiper) {
        updateControls(swiper);
      },
    },
  });

  function updateControls(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const paginationEl = activeSlide.querySelector(".tend_hero_slider_pagination");

    if (!paginationEl) return;

    // Update pagination
    if (swiper.pagination && swiper.pagination.el) {
      swiper.pagination.destroy(true, true);
    }

    swiper.params.pagination.el = paginationEl;

    swiper.pagination.init();
    swiper.pagination.render();
    swiper.pagination.update();
  }

  } catch(e) { console.error(e); }
})();
})();
